import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

const authHeaders = () => {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${accessToken}` };
};

const toResult = (response) =>
  response.data.status === 'ok'
    ? { status: 'ok', data: response.data.data }
    : { status: 'error', message: response.data.message };

const toError = (error) => ({
  status: 'error',
  message: error?.response?.data?.message || 'Error inesperado'
});

export default class PosterAdsService {
  /**
   * Paginated list of poster-ads (benefits carousel of the app).
   * @param {{ page: number, limit: number, visible?: boolean|null, available?: boolean|null, countryId?: string|null }} filters
   */
  static async getAll({ page, limit, visible = null, available = null, countryId = null }) {
    try {
      const params = new URLSearchParams({ page, limit });
      if (visible !== null) params.set('visible', String(visible));
      if (available !== null) params.set('available', String(available));
      if (countryId) params.set('countryId', countryId);
      const response = await axios.get(`${adminUrl}/poster-ads?${params.toString()}`, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }

  static async create(payload) {
    try {
      const response = await axios.post(`${adminUrl}/poster-ads`, payload, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }

  static async update(posterAdId, payload) {
    try {
      const response = await axios.put(`${adminUrl}/poster-ads/${posterAdId}`, payload, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }

  static async remove(posterAdId) {
    try {
      const response = await axios.delete(`${adminUrl}/poster-ads/${posterAdId}`, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }
}
